import React from 'react';
import { Link } from 'react-router-dom';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();
  
  return (
    <footer className="bg-osrs-dark-brown border-t-3 border-osrs-gold pt-8 pb-6 mt-12">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="md:col-span-2">
            <h3 className="text-osrs-gold font-bold uppercase mb-4">OSRS Design System</h3>
            <p className="text-osrs-yellow mb-2">
              A comprehensive design system based on Old School RuneScape.
            </p>
            <p className="text-osrs-yellow mb-4">
              Created for designers and developers to build consistent and authentic OSRS-styled interfaces.
            </p>
            <p className="text-osrs-yellow">
              Crafted by{' '}
              <a 
                href="https://milkbar.framer.ai"
                target="_blank"
                rel="noopener noreferrer"
                className="text-osrs-gold hover:text-osrs-yellow transition-colors"
              >
                Milk Bar Design
              </a>
              {' '}— Digital experiences for the modern world.
            </p>
          </div>
          
          <div>
            <h3 className="text-osrs-gold font-bold uppercase mb-4">Resources</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/foundations/colors" className="text-osrs-yellow hover:text-osrs-gold">
                  Color System
                </Link>
              </li>
              <li>
                <Link to="/foundations/typography" className="text-osrs-yellow hover:text-osrs-gold">
                  Typography
                </Link>
              </li>
              <li>
                <Link to="/components" className="text-osrs-yellow hover:text-osrs-gold">
                  Component Library
                </Link>
              </li>
              <li>
                <Link to="/resources" className="text-osrs-yellow hover:text-osrs-gold">
                  Download Assets
                </Link>
              </li>
            </ul>
          </div>
          
          <div>
            <h3 className="text-osrs-gold font-bold uppercase mb-4">Links</h3>
            <ul className="space-y-2">
              <li>
                <a 
                  href="https://oldschool.runescape.com" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-osrs-yellow hover:text-osrs-gold"
                >
                  OSRS Official Site
                </a>
              </li>
              <li>
                <a 
                  href="https://github.com/t8or/osrs-design-system" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-osrs-yellow hover:text-osrs-gold"
                >
                  GitHub Repository
                </a>
              </li>
              <li>
                <a 
                  href="https://milkbar.framer.ai" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="text-osrs-yellow hover:text-osrs-gold"
                >
                  Milk Bar Design
                </a>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-osrs-border mt-8 pt-6">
          <div className="flex flex-col md:flex-row justify-between items-center text-center md:text-left">
            <p className="text-osrs-yellow text-sm">
              © {currentYear} Milk Bar Design. All rights reserved.
            </p>
            <p className="text-osrs-yellow text-xs mt-2 md:mt-0">
              Old School RuneScape and RuneScape are registered trademarks of Jagex Ltd.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 